module.exports = __webpack_public_path__ + "img/icon_dialog_svip_level10.53fd8ba8.png";